<app-filter-item [title]="'Timeframe preset'" [value]="timeframePresetValue" [clearFilter]="clearFilter">
  <div class="timeframe-preset">
    <mat-form-field appearance="outline" class="timeframe-preset__week-month-select">
      <mat-select placeholder="Timeframe" [(ngModel)]="selectedTimeframePreset" (ngModelChange)="onChange($event)">
        <mat-option *ngFor="let item of timeframePresetOptions" [value]="item.value">
          {{item.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</app-filter-item>
